module.exports = __webpack_public_path__ + "static/media/27_A.1fee0d04.png";